import React, {Component} from 'react';
import ApiService from './ApiService';

/**
 * Class for dashboard temples page.
 *
 * @class      DashboardTemples (name)
 */
class DashboardTemples extends Component {

  constructor(props) {
    super(props);

    this.state = {
      temples: [],
      loading: true,
    };

    ApiService.loadJSON(__API_URL__ + `/admin/temple`)
      .then(templesData => {

        if (templesData.authentication === false) {
          alert(`Not Authorized`);
          window.location.href = `/`;
          return;
        }

        this.setState({
          temples: templesData || [],
          loading: false,
        });
      });
  }

  /**
   * Opens an add temple modal.
   */
  openAddTempleModal() {
    document.getElementById(`new-temple-name`).value = ``;
    this.setState({
      templeAddModalOpen: true,
    });
  }

  /**
   * Closes an add temple modal.
   */
  closeAddTempleModal() {
    this.setState({
      templeAddModalOpen: false,
    });
  }

  /**
   * Opens temple hide delete modal box.
   */
  openTempleHideModal(temple, event) {
    event.stopPropagation();
    this.setState({
      templeHideModalOpen: true,
      templeHideModalOpenTemple: temple,
    });
  }

  /**
   * Closes temple hide delete modal box.
   */
  closeTempleHideModal() {
    this.setState({
      templeHideModalOpen: false,
      templeHideModalOpenTemple: null,
    });
  }

  /**
   * sets temple hidden true/false
   */
  setTempleHidden(temple) {

    const hidden = document.getElementById(`temple-hide-input`).value;

    ApiService.loadJSON(__API_URL__ + `/admin/temple/${temple.id}/hide`, `put`, {hidden})
      .then(temple => {
        let temples = this.state.temples;
        let templeId = temple.id;
        let templeToUpdate = temples.find(temple => temple.id === templeId);

        templeToUpdate.hidden = temple.hidden;
        this.setState({
          temples,
        });
        this.closeTempleHideModal();
      });
  }


  /**
   * Removes a temple.
   *
   * @param      {Object}  event   The event
   */
  removeTemple(temple) {
    
    let result = confirm(`Are you sure you want to delete the temple?`);
    let templeId = temple.id;

    if (result) {
      ApiService.loadJSON(__API_URL__ + `/admin/temple/` + templeId, `delete`)
        .then(() => {
          let temples = this.state.temples;
          let templeToRemoveIndex = temples.findIndex(temple => temple.id === templeId);
          temples.splice(templeToRemoveIndex, 1);

          this.setState({
            temples,
          });

          this.closeTempleHideModal();
        });
    }
  }

  /**
   * Got to clicked temple page
   *
   * @param      {number}  temple  The temple
   */
  goToTemple(temple) {
    this.props.history.push(`/user/temple/${temple.id}`);
  }

  addNewTemple() {

    let templeName = document.getElementById(`new-temple-name`).value;

    if (!templeName.trim()) {
      alert(`Temple Name cannot be blank`);
      return;
    }

    ApiService.loadJSON(__API_URL__ + `/admin/temple/`, `post`, {name: templeName})
      .then(temple => {
        let temples = this.state.temples;
        temple.uploaders = [];
        temple.date = 0;
        temples.push(temple);
        this.setState({
          temples,
          templeAddModalOpen: false,
        });

      });
  }

  render() {

    let temples = this.state.temples || [];
    const addTempleModalOpenClass = this.state.templeAddModalOpen ? ` in show ` : ` hidden `;
    const templeHideModalOpenClass = this.state.templeHideModalOpen ? ` in show ` : ` hidden `;
    const templeHideModalOpenTemple = this.state.templeHideModalOpenTemple;

    temples = temples.map(temple => (
      <div key={temple.id} onClick={this.goToTemple.bind(this, temple)}
        className={`list-group-item row ${temple.hidden ? `temple-hidden` : ``}`}>
        <span className="temple-name col-xs-3">{temple.name}</span>
        <span className="user-count col-xs-3 text-center">
          <span className="fa fa-user-o"></span> {temple.uploaders.length}
        </span>
        <span className="days-count col-xs-4">
          <span className="fa fa-clock-o"></span> {temple.date === 0 ? `No Images` : temple.date}
        </span>
        <span className="edit-temple col-xs-1 text-left"
          onClick={this.openTempleHideModal.bind(this, temple)}>
          <span className="fa fa-pencil"></span>
        </span>

        <span className="right-arrow col-xs-1 text-center">
          <span className="fa fa-angle-right"></span>
        </span>
      </div>
    ));

    return (
      <div className="dashboard-temples">

        <AddTempleModal
          modalOpenClass={addTempleModalOpenClass}
          closeModalAction={this.closeAddTempleModal.bind(this)}
          addNewTemple={this.addNewTemple.bind(this)} />

        <TempleHideDeleteModal
          modalOpenClass={templeHideModalOpenClass}
          closeModalAction={this.closeTempleHideModal.bind(this)}
          temple={this.state.templeHideModalOpenTemple}
          removeTemple={this.removeTemple.bind(this, templeHideModalOpenTemple)}
          setTempleHidden={this.setTempleHidden.bind(this, templeHideModalOpenTemple)} />

        <div className="list-group">
          {
            this.state.loading ? (<div className="loader dark small"></div>) : temples
          }
        </div>

        <div className="new-temple-cont">
          <button
            className="btn btn-primary btn-block"
            onClick={this.openAddTempleModal.bind(this)}>

            <span className="btn-icon fa fa-plus"></span> Add New Temple
          </button>
        </div>
      </div>
    );
  }
}

/**
 * Adds a temple modal.
 *
 * @class      AddTempleModal (name)
 * @param      {<type>}  props   The properties
 * @return     {<type>}  { description_of_the_return_value }
 */
const AddTempleModal = props => (
  <div>
    <div className={`modal-backdrop ` + props.modalOpenClass} onClick={props.closeModalAction}></div>
    <div className={`modal add-temple-modal ` + props.modalOpenClass} tabIndex="-1">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={props.closeModalAction} >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">Add New Temple</h4>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="new-temple-name">Enter New Temple Name</label>
              <input type="text" className="form-control" id="new-temple-name" placeholder="Temple name" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={props.closeModalAction}>
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={props.addNewTemple}>Add</button>
          </div>
        </div>
      </div>
    </div>
  </div>
);


/**
 * Temple hide delete modal.
 *
 * @class      TempleHideDeleteModal (name)
 * @param      {<type>}                        props   The properties
 * @return     {(Array|Date|Function|Object)}  { description_of_the_return_value }
 */
const TempleHideDeleteModal = props => (
  <div>
    <div className={`modal-backdrop ` + props.modalOpenClass} onClick={props.closeModalAction}></div>
    <div className={`modal hide-temple-modal ` + props.modalOpenClass} tabIndex="-1">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={props.closeModalAction} >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">Update Temple</h4>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="hide-temple">Set Hidden</label>
              <select className="form-control" id="temple-hide-input" value={props.temple ? props.temple.hidden : `true`}>
                <option value="true">
                  True
                </option>
                <option value="false">
                  False
                </option>
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger pull-left"
              onClick={props.removeTemple}>Delete</button>
            <button
              type="button"
              className="btn btn-default"
              onClick={props.closeModalAction}>
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={props.setTempleHidden}>Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
);


export default DashboardTemples;



// WEBPACK FOOTER //
// ./js/DashboardTemples.js